import React from 'react';
import { observer } from 'mobx-react';

const Welcome = observer((props) => {

  return (
    <>
      <h1>Loading...</h1>
      <div class="row">   
        <div class="col-md p-4">
          <div class="spinner-border spinner-border-lg text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </>
  );
});

export default Welcome;